






import Vue from 'vue'

export default Vue.extend({
  name: 'CategoryCircle',

  props: {
    label: {
      type: String as Prop<string>,
      default: ''
    },
    value: {
      type: Number as Prop<number>
    },
    limit: {
      type: Number as Prop<number>,
      default: 100
    },
    color: {
      type: String as Prop<string>,
      default: '#B4596F'
    }
  }
})
